import { Component, computed, inject, input, signal } from "@angular/core"
import { FieldType, Image } from "redlineLibs"
import {
  SvgGraphic,
  TimelineSvgGraphicsService,
} from "../../pages/timeline/timeline.svg-graphics.service"
import { EditorService } from "../../editor/services/editor.service"
import { NgOptimizedImage } from "@angular/common"
import { SvgGraphics } from "redlineLibs"
import { StorageService } from "../../../services/storage.service"

@Component({
  imports: [
    NgOptimizedImage,
  ],
  standalone: true,
  template: `
    <div class="row gap-0">
      @for (svg of svgGraphics; track svg.label) {
        <div
          [style.box-shadow]="selectedSvg() === svg.label || hover() === svg.label ? 'inset 0px 0px 4px 4px rgba(255, 0, 0, 0.9)' : undefined"
          class="outline outline-1 outline-black outline-offset-0 cursor-pointer bg-white"
          (mouseover)="hover.set(svg.label)"
          (mouseout)="hover.set(null)"
          (click)="changeSvg(svg.label)"
        >
          <img 
            [ngSrc]="svg.fileName" 
            style="width: 80px; height: 80px" 
            width="80" 
            height="80" 
            alt=""
          />
        </div>
      }
    </div>
  `,
  selector: "e2e-svg-edit",
})
export class SvgEditComponent {
  private editorService = inject(EditorService)
  private svgGraphicsService = inject(TimelineSvgGraphicsService)
  private storageService = inject(StorageService)

  rowId = input.required<string>()
  hover = signal<SvgGraphic["label"] | null>(null) // : SvgGraphic["label"] | null = null

  private _selectedSvg = signal<SvgGraphics | undefined>(undefined) // content.rows[this.rowId].svgGraphics
  selectedSvg = computed(() =>
    this._selectedSvg() || (this.editorService.editorContent()?.rows[this.rowId()] as Image || undefined)?.svgGraphics
  )

  svgGraphics: SvgGraphic[] = this.svgGraphicsService.svgGraphics.map((svgGraphic) => ({
    ...svgGraphic,
    fileName: this.storageService.getFileUrl(svgGraphic.fileName),
  }))

  changeSvg(svgGraphics: SvgGraphics) {
    const content = this.editorService.editorContent()
    if (content?.rows[this.rowId()].field === FieldType.IMAGE) {
      const imageRow = content.rows[this.rowId()] as Image

      console.log("svgGraphics", svgGraphics)
      console.log("this.selectedSvg()", this.selectedSvg())

      if (this.selectedSvg() === svgGraphics) {
        console.log("this.selectedSvg() === svgGraphics")
        imageRow.svgGraphics = null
        this._selectedSvg.set(undefined)
      }
      if (this.selectedSvg() !== svgGraphics) {
        imageRow.svgGraphics = svgGraphics
        this._selectedSvg.set(svgGraphics)
      }
      this.hover.set(null)

      this.editorService.queueEditor({
        ...content,
        rows: {
          ...content.rows,
          [this.rowId()]: {
            ...imageRow,
            filePath: "",
            fileType: "",
          },
        },
      })
    }
  }

}
